import $ from 'jquery'
$('.footer__back-to-top > .circle').on('click', function () {
  $('html, body').animate({ scrollTop: 0 }, 500)
})
